/**
 * Where a prospect reaches a person at Avrio from the self-serve flow: plan
 * activation from the trial, and hiring volumes above what self-serve quotes.
 *
 * A personal address is deliberate for the early self-serve pilot -- Nachi
 * wants to speak to every first customer -- and is a single constant so it
 * becomes a shared inbox without a code search.
 */
export const SELF_SERVE_CONTACT_EMAIL = 'nachi@goavrio.com';

/** A mailto: link to the self-serve contact, with subject and body prefilled. */
export const contactHref = (subject: string, body: string): string =>
  `mailto:${SELF_SERVE_CONTACT_EMAIL}?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`;
